import React, { useEffect } from "react";

import Image from "next/image";

import clx from "classnames";
import { ActionComment } from "../../../../types/Action";
import formatTimestamp from "../../../../helpers/formatTimestamp";

import Typography from "../../../common/Typography/Typography";
import CommentForm, { OnCommentAdded } from "./CommentForm/CommentForm";

import styles from "./ActionViewComments.module.css";

interface Props {
    comments?: ActionComment[];
    actionId: string;
    onCommentAdded?: OnCommentAdded;
}

const ActionViewComments = ({ comments, actionId, onCommentAdded }: Props) => {
    const commentsListRef = React.useRef<HTMLUListElement>(null);
    const uniqueRenderKey = React.useRef<string>(Date.now().toString());

    /** On comments changing and being added, scroll to the bottom */
    useEffect(() => {
        if (commentsListRef.current) {
            commentsListRef.current.scrollTop = commentsListRef.current.scrollHeight;
        }
    }, [comments]);

    return (
        <div
            className={clx(
                "flex-shrink-0 flex flex-col gap-1 w-full justify-self-end md:w-[30rem]",
                styles.commentListContainerMobileStyles,
                styles.padding,
                styles.verticalSeparator,
                styles.padding
            )}
        >
            <Typography as="span" variant="emphasis">
                Comments <span className={styles.numberOfComments}>{comments ? comments.length : 0}</span>
            </Typography>
            <ul ref={commentsListRef} className={styles.commentList}>
                {comments &&
                    comments.map((comment) => (
                        <li key={`${comment.Note}-${uniqueRenderKey.current}`} className={styles.commentListItem}>
                            <div className="pb-0.25">
                                <Typography as="p" variant="meta">
                                    {comment.Note}
                                </Typography>
                            </div>
                            <div className="flex flex-row type-meta text-pine-600">
                                <span>{comment.UpdateBy}</span>
                                <Image
                                    src="/images/action-commented-by-separator.svg"
                                    width={3.5}
                                    height={3.5}
                                    alt="action author detail separator"
                                    className="ml-[7px] mr-[7px]"
                                />
                                <span>{formatTimestamp(comment?.CreatedAt as string)}</span>
                            </div>
                        </li>
                    ))}
            </ul>
            <CommentForm actionId={actionId} onCommentAdded={onCommentAdded} />
        </div>
    );
};

export default ActionViewComments;
